<template>
	<section>
		<div>
			<!--工具条-->
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters"  size="mini">
					<el-form-item label="项目名称">
						<el-select v-model="filters.projectId" filterable>
							<el-option
								v-for="item in projects"
								:label="item.name"
								:value="item.projectId" :key="item.projectId">
							</el-option >
						</el-select>
					</el-form-item>
					<el-form-item label="时间">
						<el-date-picker v-model="filters.time" type="date"  value-format="yyyy-MM-dd"> </el-date-picker>
					</el-form-item>
					
					<el-form-item>
						<my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
					</el-form-item>
				</el-form>
			</el-col>

			<div id="formDaily"  v-loading="listLoading" style="min-height:500px"  element-loading-text="报表生成中"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="title">
					<span>每日运维记录</span>
					<span>日期：{{ date }}</span>
				</div>
				<div id="con2add"></div>
			</div>


			<p>异常信息详情</p>
			<ul style="width: 100%; max-height: 150px; margin-bottom: 80px; overflow-y: scroll;">
				<li v-for="err in errList" :key="err">{{err}}</li>
			</ul>
		</div>
		
	</section>
</template>

<script>
	import { getProjects,getDailyMaintRecords} from '../../api/api';
	import {formatDateDay} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'

	export default {
	components: { myButton },
		data() {
			return {
				filters: {
					projectId:"",
                    time:''
				},
				listLoading: false,
				dataList:[],
				projects:[],
				formHeight:0,
				date:'',
				errList:[]
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="export"){
					this.downFileZip();
				}
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
					}
				});
			},
			//获取历史数据信息
			getDataList(){
				let para = {
                    projectId: this.filters.projectId,
					time: this.filters.time
				};
				this.listLoading = true;
                getDailyMaintRecords(para).then((res) => { 
					this.listLoading = false;
					if(res.data.result=="true"||res.data.result==true){
						this.dataList = res.data.datas; 
						if(this.dataList.length>0){
							this.date = this.dataList[0].date; 
							this.initTotalData();
						}

					}else{
						this.$message({
							message: "查询失败，请重试",
							type: 'error'
						})
					}
                });
			},  
			initTotalData(){
				//先删除上次生成标签
				var body = document.getElementById('con2add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";
				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr  style="font-size:14px">'
									+'<td rowspan="2"  width="40px">序号</td>'
									+'<td rowspan="2" >点位名称</td>'
									+'<td rowspan="2"  width="60px">采集率（%）</td>'
									+'<td colspan="3" >定时远程自检</td>'
									+'<td colspan="3" >远程维护</td>'
									+'<td colspan="6" >数据审核</td>'
								+'</tr>'
								+'<tr  style="font-size:14px">'
									+'<td   width="40px">状态</td>'
									+'<td   width="40px">时间</td>'
									+'<td   width="40px">差值</td>'
									+'<td   width="40px">运行状况</td>'
									+'<td   width="40px">时钟日历</td>'
									+'<td   width="40px">数据传输</td>'
									+'<td >噪声事件录音</td>'
									+'<td >风速≥5m/s（条数）</td>'
									+'<td >降雨量＞0（条数）</td>'
									+'<td   width="40px">小时数据</td>'
									+'<td   width="40px">昼间数据</td>'
									+'<td   width="40px">夜间数据</td>'
								+'</tr>'
							+'<tbody>';
				//head结束，开始添加内容
				var i=0;
				this.errList=[];
				this.dataList.forEach(ele => {
					str+='<tr  style="font-size:14px">';
						str+='<td>'+(i+1)+'</td>';
						str+='<td>'+ele.name+'</td>';
						str+='<td>'+ele.dar+'</td>';
						str+='<td>'+ele.selfCheckStatus+'</td>';
						str+='<td>'+ele.selfCheckTime+'</td>';
						str+='<td>'+ele.selfCheckDiff+'</td>';
						str+='<td>'+ele.runStatus+'</td>';
						str+='<td>'+ele.timeStatus+'</td>';
						str+='<td>'+ele.dataTrans+'</td>';
						str+='<td>'+ele.recording+'</td>';
						str+='<td>'+ele.ws+'</td>';
						str+='<td>'+ele.rc+'</td>';
						str+='<td>'+ele.hourData+'</td>';
						str+='<td>'+ele.ld+'</td>';
						str+='<td>'+ele.ln+'</td>';
					str+='</tr>';
					i++;

					//处理异常信息
					var strErr="";
					if(ele.selfCheckStatus=="异常"){
						if(ele.selfCheckDiff=="-"){
							strErr+="自检异常原因:无自检;"
						}else{
							strErr+="自检异常原因:"+ele.selfCheckReason+";"
						}
					}

					if(ele.runStatus=="异常"){
						strErr+="远程维护异常原因:分钟、小时或天数据未更新到最新;"
					}

					if(ele.hourData=="异常"){
						strErr+="小时数据异常原因:"+ele.hourDataReason+";";
					}

					if(ele.ld=="异常"){
						strErr+="昼间数据异常原因:"+ele.dayDataLdError+";";
					}

					if(ele.ln=="异常"){
						strErr+="夜间数据异常原因:"+ele.dayDataLnError+";";
					}

					if(strErr!=""){
						strErr=ele.name+"------"+strErr;
						this.errList.push(strErr);
					}

				});
				div.innerHTML=str;
				body.appendChild(div);
			},
			downFileZip(){
                require.ensure([], () => {
					let tHeader3=["每日运维记录   日期："+this.date,'','','','','','','','','','','','',''];
                    let tHeader2=['点位名称','采集率（%）','定时远程自检','','','远程维护','','','数据审核','','','','',''];
                    let tHeader1=['','','状态','时间','差值','运行状况','时钟日历','数据传输',
							'噪声事件录音','风速≥5m/s（条数）','降雨量＞0（条数）','小时数据','昼间数据','夜间数据'];

                    let merges = [
						"A1:N1",
                        "A2:A3",
                        "B2:B3",
                        "C2:E2",
                        "F2:H2",
                        "I2:N2"
                    ]; 
                    const { export_json_to_excel_Three } = require('vendor/Export2Excel');
                    const filterVal = ['name', 'dar', 'selfCheckStatus','selfCheckTime','selfCheckDiff','runStatus','timeStatus','dataTrans',
							'recording','ws','rc','hourData','ld','ln' ];  
					
                    var data=[];
                    data.push(this.formatJson(filterVal, this.dataList));

                    var sheetName=[];
                    sheetName.push('Sheet1');

                    export_json_to_excel_Three(tHeader1,tHeader2,tHeader3,data, '每日运维记录-'+this.filters.time,sheetName,merges);

                }) 
			} ,
			formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var start = new Date();
				start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= formatDateDay(start);
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		}, 
	}

</script>

<style  scoped>
	@import '../../../static/ywPort.css';
</style>


// WEBPACK FOOTER //
// DailyMaintRecords.vue?6d9ec9e0